import React from 'react';
import Header from '../Header';
import CityWiseLead from './CityWiseLead';

const MainCityWiseLeadPage = () => {
  return (
    <div>
      <Header />
      <CityWiseLead/>
    </div>
  );
};

export default MainCityWiseLeadPage;